module.exports = __webpack_public_path__ + "48348a709a9a88132d0dfbbfc61af743.png";